import { PlusCircleOutlined, DeleteOutlined } from '@ant-design/icons';
import { Button, Popconfirm } from 'antd';
import gql from 'graphql-tag';
import { useAuthedMutation } from 'utils/qlAuth';

export const StoryController_createOneFrame = (props: { storyId: number; timeStart: number; onAdd: Function; frameId: number }) => {
  const [newFrame] = useAuthedMutation(
    gql`
      mutation StoryController_createOneFrame($storyId: Int!, $frameId: Int!, $input: JSON!) {
        StoryController_createOneFrame(storyId: $storyId, frameId: $frameId, config: $input) {
          id
        }
      }
    `,
  );

  return (
    <Button
      title="Копировать кадр"
      size="small"
      onClick={async () => {
        const res = await newFrame({
          variables: {
            storyId: props.storyId,
            input: { timeStart: props.timeStart },
            frameId: props.frameId,
          },
        });
        if (res.data?.StoryController_createOneFrame) {
          props.onAdd(res.data.StoryController_createOneFrame);
        }
      }}
      type="default"
    >
      <PlusCircleOutlined />
    </Button>
  );
};

export const StoryController_removeFrame = (props: { frameId: number; onRemove: Function }) => {
  const [removeFrame] = useAuthedMutation(
    gql`
      mutation StoryController_removeFrame($frameId: Int!) {
        StoryController_removeFrame(frameId: $frameId)
      }
    `,
  );
  return (
    <Popconfirm
      title="Вы уверены, что хотите удалить этот кадр?"
      onConfirm={async () => {
        await removeFrame({
          variables: {
            frameId: props.frameId,
          },
        });

        props.onRemove(props.frameId);
      }}
      okText="Да"
      cancelText="Нет"
    >
      <Button type="default" danger size="small">
        <DeleteOutlined />
      </Button>
    </Popconfirm>
  );
};
